<div *ngIf="device" class="text-size">
    <div class="p-3  shadow-right rounded-1 min-vh-100">
        <div class="mb-4">
            <strong
                class="d-flex justify-content-center w-100 title-fs mb-3 text-slide-title">{{ 'DEVICE.DETAIL' | translate }}</strong>
            <div class="d-flex align-items-center">
                <a (click)="back()" class="cursor d-flex align-items-center">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                    {{ 'BUTTONS.BACK' | translate }}
                </a>
            </div>
        </div>

        <div class="d-flex align-items-center">
            <span class="star-icon" [ngClass]="device.isFavorite ? 'fas fa-star' : 'far fa-star'"
                aria-label="Toggle favorite" role="button" tabindex="0"></span>
            <div class="text-container ms-1">
                <strong>{{ device.serialNumber }}</strong>
            </div>
        </div>



        <div class=" row mt-3">
            <div class="col-5">
                <button type="button" class="secondary-button edit-button" (click)="onModifyDevice()">
                    <img src="icon/edit-pencil.svg" /> {{ 'BUTTONS.MODIFY' | translate }}
                </button>
            </div>
            <div class="col-7">
                <button type="button" class="tertiary-button delete-button" (click)="onDelete()">
                    <img src="icon/delete.svg" /> {{ 'DEVICE.DELETE_DEVICE' | translate }}
                </button>
            </div>
        </div>
        <hr>
        <div class="device-details mt-3 mb-3 p-2">
            <div class="row mb-2">
                <div class="col-6">
                    <div class="text-muted">{{ 'DEVICE.COMPANY' | translate }}</div>
                    <div>{{ companyName }}</div>
                </div>
                <div class="col-6">
                    <div class="text-muted">{{ 'DEVICE.LAST_CALIBRATION' | translate }}</div>
                    <div>{{ device.lastCalibration | date:'dd/MM/yyyy' }}</div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-6">
                    <div class="text-muted">{{ 'DEVICE.BATTERY' | translate }}</div>
                    <span *ngIf="device && getDeviceStatusInfo(device).isConnected">
                        <span title="Battery Level">
                            <ng-container [ngSwitch]="getBatteryIcon(device)">
                                <span *ngSwitchCase="'charging'"><svg-icon src="./icon/charging-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" title="Charging"></svg-icon></span>
                                <span *ngSwitchCase="'low'"><svg-icon src="./icon/low-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                                <span *ngSwitchCase="'unknown'"></span>
                                <span *ngSwitchDefault><svg-icon src="./icon/battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                                <span *ngSwitchCase="'medium'"><svg-icon src="./icon/medium-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                                <span *ngSwitchCase="'battery'"><svg-icon src="./icon/battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                                <span *ngSwitchCase="'full-battery'"><svg-icon src="./icon/full-battery.svg" [svgStyle]="{width: '2.2em', height: '2.2em'}" [title]="device.batteryLevel + '%'" ></svg-icon> {{device.batteryLevel}}%</span>
                            </ng-container>
                        </span>
                    </span>
                </div>
                <div class="col-6">
                    <div class="text-muted">{{ 'DEVICE.STATUS' | translate }}</div>
                    <span *ngIf="device">
                        <svg-icon
                            [src]="getStatusIcon(device)"
                            [svgStyle]="{width: '1.5em', height: '1.5em'}"
                            [title]="getStatusTitle(device)"
                        ></svg-icon>
                        <span class="ms-2">{{ getStatusTitle(device) }}</span>
                    </span>
                </div>
            </div>
        </div>
        <hr>
        <div>
            <h5 (click)="toggleCurrentCtrlPoint()" class="d-flex align-items-center" style="cursor: pointer;">
                <span class="fs-6 fw-bold fs-5">{{ isEditing ? ('BUTTONS.MODIFY_CONTROL_POINT' | translate) : (ctrlPoint
                    !== null ? ('DEVICE.CURRENT_CONTROL_POINT' |
                    translate) : ('DEVICE.NO_CONTROL_POINT' | translate)) }}</span>
                <span class="material-icons">
                    {{ showCurrentCtrlPoint ? 'expand_less' : 'expand_more' }}
                </span>
            </h5>
            <div *ngIf="showCurrentCtrlPoint" class="border rounded p-3 pt-2 shadow-sm">
                <div *ngIf="ctrlPoint !== null && !isEditing">
                    <div class="row align-items-center">
                        <div class="col-9 d-flex align-items-center">
                            <img src="./icon/control-point-black.svg"
                                style="width: 24px; height: 24px; margin-right: 15px;" />
                            <div style="padding-left: 5px;">
                                <strong class="title">{{ctrlPoint?.name}}</strong>
                                <div class="description">{{ctrlPoint?.description}}</div>
                            </div>
                        </div>
                        <div class="col-3 d-flex justify-content-end edit-container">
                            <a (click)="onEditControlPoint()">
                                <img src="icon/edit-pencil.svg" />
                            </a>
                        </div>
                    </div>
                    <hr class="m-2">
                    <div class="row">
                        <div class="col-6">
                            <div class="text-muted">Site</div>
                            <div>{{controlPointSite?.nom}}</div>
                        </div>
                    </div>

                    <div class="mt-2">
                        <a (click)="navigateToDetails(ctrlPoint)" class="text-decoration-underline text-dark"
                            style="cursor: pointer;">
                            See more
                        </a>
                    </div>
                </div>
                <div *ngIf="ctrlPoint === null || isEditing">
                    <span *ngIf="ctrlPoint === null ">{{ 'ERRORS.NO_CTRL_POINT_LINKED_TO_DEVICE' | translate }}</span>
                    <div>
                        <div class="row align-items-center" *ngIf="ctrlPoint !== null || isEditing">
                            <div class="col-9 d-flex align-items-center">
                                <img src="./icon/control-point-black.svg"
                                    style="width: 24px; height: 24px; margin-right: 15px;" />
                                <div style="padding-left: 5px;">
                                    <strong class="title">{{ctrlPoint?.name}}</strong>
                                    <div class="description">{{ctrlPoint?.description}}</div>
                                </div>
                            </div>
                            <div class="col-3 d-flex justify-content-end edit-container">
                                <button type="button" class="btn btn-light btn-sm" (click)="confirmUnassign()">
                                    <span class="text-size">{{'BUTTONS.UNASSIGN' | translate}}</span>
                                </button>
                            </div>
                        </div>
                        <hr *ngIf="ctrlPoint !== null || isEditing" class="m-2">
                        
                        <!-- Site Selection -->
                        <div class="mb-3">
                            <label class="form-label">{{ 'DEVICE.SITE' | translate }}</label>
                            <app-autocomplete [options]="optionsSites"
                                placeholder="{{ 'PLACEHOLDERS.SELECT_SITE' | translate }}"
                                (optionSelected)="onOptionSiteSelected($event)">
                            </app-autocomplete>
                        </div>

                        <!-- Control Point Selection -->
                        <div class="mb-3">
                            <label class="form-label">{{ 'DEVICE.CONTROL_POINT' | translate }}</label>
                            <app-autocomplete [options]="optionsControlPoint"
                                placeholder="{{ 'PLACEHOLDERS.SELECT_CONTROL_POINT' | translate }}"
                                (optionSelected)="onOptionCpSelected($event)">
                            </app-autocomplete>
                        </div>
                        <div class="d-flex justify-content-center gap-2">
                            <button type="button" class="tertiary-button" (click)="cancelModifyAssignedCp()">
                                {{'BUTTONS.CANCEL' | translate}}
                            </button>
                            <button type="button" class="primary-button" (click)="assignCpToDevice()">
                                {{'BUTTONS.ASSIGN' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>